import { Organization, User } from '@isocel/front-common';

export interface BaseModel {
    id: string;
    name: string;
    _id?: string;
    organization?: string | Organization;
    SelectionType?: string;
    image?: string;
}

export interface Store extends BaseModel {
    code: string;
    organization: string | Organization;
    contact?: string;
    name: string;
}

export interface Supplier extends BaseModel {
    store: string | Store;
}
export enum LoadingSessionStatus {
    New = 0,
    Completed = 1,
}

export enum PackagingFlowDirection {
    ShippedToStore = 0,
    RecivedInStore = 1,
    ShippedToOrganization = 2,
    RecivedInOrganization = 3,
    ReceivedFromSupplier = 4,
    Purchase = 5,
    Sale = 6,
    Destruction = 7,
    ShipmentForRepair = 8,
    ReceptionFromRepair = 9,
    ReturnToSupplier = 10,
    Transfer = 11,
    ReceivedFromSupplierAtOrganization = 12,
    DebtReduction = 13,
    Increase = 14,
    Decrease = 15,
    AutomaticReception = 16,
}

export enum DocumentTypes {
    LettreDeVoiture = 'Lettre de voiture',
    PhotosEmballages = 'Photos emballages',
    Autres = 'Autres',
}

export enum PackagingVoucherStatus {
    Expired = 'Expiré',
    NotUsed = 'Non Utilisé',
    Used = 'Utilisé',
}

export interface LoadingSession {
    id: any;
    warehouse: BaseModel;
    store: BaseModel;
    transporter: BaseModel;
    trailerNumber: string;
    status: LoadingSessionStatus;
    createdAt: Date;
    date: Date;
    time: Date;
}

export interface Package {
    id: string;
    type: BaseModel;
    category: BaseModel;
    model: BaseModel;
    organization?: string | Organization;
    rental?: boolean;
}

export interface PackagingConfig {
    packagingTypes: BaseModel[];
    packageCategories: BaseModel[];
    packages: Package[];
}

export interface PackagingFlowItem {
    package: string | Package;
    shippedQuantity: number;
    goodCount: number;
    badCount: number;
    organizationRefused?: boolean | null;
    toBeReturned?: number;
}

export interface PackagingFlow {
    id?: string;
    _id?: string;
    createdAt?: string;
    sender: string | BaseModel | any;
    recipient: string | BaseModel | any;
    user: string | BaseModel;
    loadingSession?: string | LoadingSession;
    transportVoucher?: string;
    flowType: PackagingFlowDirection;
    packages: PackagingFlowItem[];
    type?: BaseModel[];
    comment?: string;
    originId?: string | null;
    received?: boolean;
    cmr?: string;
    organizationId?: string;
    packagingVouchers?: PackagingVoucher[];
    senderType?: string | BaseModel | any;
    recieverType?: string | BaseModel | any;
    attachments?: DocumentAttachment[];
    totalQuantity?: number;
    differenceReported?: boolean;
    transporter?: string;
    expeditionAt?: string;
    deliveredAt?: string;
    truckNumber?: string;
    orderNumber?: string;
    packagingVoucherUsed?: PackagingVoucher[];
}

export interface DocumentAttachment {
    attachmentType: DocumentTypes;
    remoteFile?: RemoteFile;
}
export interface RemoteFile {
    originalName?: string;
    filename: string;
    mimeType: string;
    bucket: string;
    createdAt?: string;
    updatedAt?: string;
    id?: string;
}

export interface OrganizationOption {
    value: string;
    id: string;
}

export interface TransporterOptions {
    transporter: string;
    value: string;
}

export interface SupplierOptions {
    supplier: string;
    value: string;
}
export interface PaginateResult<T> {
    items: T[];
    page: number;
    pageCount: number;
    pageSize: number;
    totalCount: number;
}
export interface GetAllPackagingFlowParams {
    page?: number;
    pageSize?: number;
    differenceReported?: boolean;
    packageIds?: string[];
    status?: string[];
    voucherStatus?: string[];
    storeIds?: string | string[];
    supplierIds?: string[];
    parcPalettIds?: string[];
    warehouseIds?: string[];
    transportVoucher?: string;
    flowType?: PackagingFlowDirection;
    sortField?: string;
    sortOrder?: string;
    isMounted?: boolean;
    startDate?: string | null;
    endDate?: string | null;
    organization?: string;
}

export interface PackagingVoucher {
    createdAt: string;
    flowReceptionId: string;
    flowReturningId: string;
    organization: string;
    voucherNumber: string;
    _id: string;
}
export interface VoucherResponse {
    message: string;
    success: boolean;
    voucher: PackagingVoucher;
}

export enum Permission {
    superAdmin = 'superAdmin',
    orgAdmin = 'orgAdmin',
    orgUser = 'orgUser',
    storeAdmin = 'storeAdmin',
    storeUser = 'storeUser',
    users = 'users',
    organizations = 'organizations',
    logAs = 'logAs',
    dashboard = 'dashboard',
    roles = 'roles',
    staticPages = 'staticPages',
}

export enum RoleSlug {
    superAdmin = 'superAdmin',
    orgAdmin = 'orgAdmin',
    orgUser = 'orgUser',
    storeAdmin = 'storeAdmin',
    storeUser = 'storeUser',
}

export interface StoreUser extends User {
    store?: string;
}
